import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  addNewRatingReducer,
  deleteProductRatingReducer,
  getAllCategoryReducer,
  getAllProductReducer,
  getProductDetailReducer,
  getProductRatingReducer,
} from "./reducer/productReducer";
import {
  addNewAddressReducer,
  changePasswordReducer,
  deleteUserAddressReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  updateAddressReducer,
  userContactUsReducer,
  userLoginReducer,
  userProfileReducer,
  userRegisterReducer,
} from "./reducer/userReducer";
import {
  addCartItemReducer,
  deleteCartItemReducer,
  getAllCartItemReducer,
  updateCartItemReducer,
} from "./reducer/cartReducer";
import {
  createNewOrderReducer,
  createOrderPaymentReducer,
  getAllOrderListReducer,
  getOrderInvoiceReducer,
  orderCancelReducer,
  updateOrderAddressReducer,
} from "./reducer/orderReducer";
import { getAllBlogReducer, getBlogDetailReducer } from "./reducer/blogReducer";

// get user from localStorage
// const userFromLocalStorage = localStorage.getItem("saajToken")
//   ? JSON.parse(localStorage.getItem("saajToken"))
//   : {};

const reducer = combineReducers({

  getAllProduct: getAllProductReducer,
  getProductDetail: getProductDetailReducer,

  getProductRating: getProductRatingReducer,
  addNewRating: addNewRatingReducer,
  deleteProductRating:deleteProductRatingReducer,

  getAllCategory: getAllCategoryReducer,

  userRegister: userRegisterReducer,
  userLogin: userLoginReducer,
  userProfile: userProfileReducer,
  updateProfile: updateAddressReducer,
  forgotPassword: forgotPasswordReducer,
  changePassword: changePasswordReducer,
  resetPassword: resetPasswordReducer,

  userContactUs: userContactUsReducer,

  addNewAddress: addNewAddressReducer,
  deleteUserAddress: deleteUserAddressReducer,
  addCartItem: addCartItemReducer,
  updateCartItem: updateCartItemReducer,
  deleteCartItem: deleteCartItemReducer,
  getAllCartItem: getAllCartItemReducer,

  createOrderPayment: createOrderPaymentReducer,
  createNewOrder: createNewOrderReducer,
  getAllOrderList: getAllOrderListReducer,
  getOrderInvoice: getOrderInvoiceReducer,
  orderCancel: orderCancelReducer,
  updateOrderAddress:updateOrderAddressReducer,

  getBlogDetail:getBlogDetailReducer,
  getAllBlogs:getAllBlogReducer
});

// MIDDLEWARE // THUNK
const middleware = [thunk];

// INITIAL STATE
// const initialState = {
//   userLogin: {
//     userInfo: userFromLocalStorage,
//   },
// };

const store = createStore(
  reducer,
  {},
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
